
import React from 'react';

const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  SEND_DRAW_REQUEST: "FORM/SEND_DRAW_REQUEST",
  SEND_DRAW_SUCCESS: "FORM/SEND_DRAW_SUCCESS",
  SEND_DRAW_FAILURE: "FORM/SEND_DRAW_FAILURE",
};

const initialState = {
  drawStatus: '',
};

const FormReducer = (state = { ...initialState }, action) => {
  switch (action.type) {
    case HYDRATE: {
      let { form } = action.payload;
      return {
        ...state,
      };
    }
    case types.SEND_DRAW_REQUEST:
      return { ...state, drawStatus: 'FETCHING'};
    case types.SEND_DRAW_SUCCESS:
      return { ...state, drawStatus: 'SUCCESS'};
    case types.SEND_DRAW_FAILURE:
      return { ...state, drawStatus: 'FAILURE'};
    default:
      return state;
  }
};

export const actions = {
  sendDrawRequest: (campaign) => ({
    type: types.SEND_DRAW_REQUEST,
    campaign
  }),
  sendDrawSuccess: (campaign) => ({
    type: types.SEND_DRAW_SUCCESS,
    campaign
  }),
  sendDrawFailure: (campaign) => ({
    type: types.SEND_DRAW_FAILURE,
    campaign
  }),
};

export default FormReducer;
